import axios from "axios";

if (localStorage.getItem("token") != null) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    "token"
  );
} else {
  let params = new URLSearchParams(window.location.search.substring(1));
  if (params.get("token") != null) {
    localStorage.setItem("token", params.get("token"));
    axios.defaults.headers.common["Authorization"] = params.get("token");
  }
}
// baseURL: "https://api.bilfen.com/evdeki-ogretmen/" Non-Redis
const axiosInstance = axios.create({
  baseURL: "https://apiv2.bilfen.com/evdeki-ogretmen/"
});
export default axiosInstance;
